import { type ReactNode } from 'react';

import { type AdminFeedback } from '../../types/feedback';
import { FEEDBACK_STATUS_LABELS, FEEDBACK_TYPE_LABELS } from '../../utils/feedback-labels';
import { SEVERITY_COLORS, SEVERITY_LABELS } from '../../utils/severity-labels';

const Field = ({ label, children }: { label: string; children: ReactNode }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-wide text-text-grey mb-1">{label}</p>
    {children}
  </div>
);

export const FeedbackSummaryCard = ({ feedback }: { feedback: AdminFeedback }) => (
  <div className="rounded-xl border border-black/10 bg-white p-6">
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <span
        className={`inline-block rounded-sm border px-2.5 py-1 text-xs font-medium ${SEVERITY_COLORS[feedback.severity]}`}
      >
        {SEVERITY_LABELS[feedback.severity]}
      </span>
      <span className="rounded-sm border border-black/10 bg-brand-beige-tint-1 px-2.5 py-1 text-xs font-medium text-brand-blue">
        {FEEDBACK_TYPE_LABELS[feedback.type]}
      </span>
      <span className="rounded-sm border border-indigo-300 bg-indigo-50 px-2.5 py-1 text-xs font-medium text-indigo-700">
        {FEEDBACK_STATUS_LABELS[feedback.status]}
      </span>
    </div>

    <div className="space-y-4">
      <Field label="Användarens fråga">
        <div className="rounded-sm border border-black/10 bg-brand-beige-tint-1 px-4 py-3 text-sm text-brand-blue">
          {feedback.userMessage}
        </div>
      </Field>

      <Field label="Assistants svar">
        <div className="rounded-sm border border-black/10 bg-brand-beige-tint-1 px-4 py-3 text-sm text-brand-blue whitespace-pre-wrap">
          {feedback.assistantAnswer}
        </div>
      </Field>

      {feedback.correctedAnswer ? (
        <Field label="Korrekt svar">
          <div className="rounded-sm border border-emerald-300 bg-emerald-50 px-4 py-3 text-sm text-emerald-800 whitespace-pre-wrap">
            {feedback.correctedAnswer}
          </div>
        </Field>
      ) : null}

      {feedback.expectedIntent ? (
        <Field label="Förväntad intent">
          <span className="rounded-sm border border-black/10 bg-brand-beige-tint-1 px-2.5 py-1 text-xs font-medium text-brand-blue">
            {feedback.expectedIntent}
          </span>
        </Field>
      ) : null}

      {feedback.notes ? (
        <Field label="Noteringar">
          <div className="rounded-sm border border-black/10 bg-brand-beige-tint-1 px-4 py-3 text-sm text-text-grey whitespace-pre-wrap">
            {feedback.notes}
          </div>
        </Field>
      ) : null}
    </div>
  </div>
);
